import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/common/Collapsible';
import { memo, ReactNode, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@/utils/utils';

interface TestSectionProps {
    title: string,
    isExpand?: boolean,
    children: ReactNode,
    className?: string,
    classNameTitle?: string
}

const TestCollapsible = ({
    title,
    isExpand = true,
    children,
    className,
    classNameTitle
}: TestSectionProps) => {
    const [open, setOpen] = useState<boolean>(isExpand);
    return (
        <Collapsible open={open} onOpenChange={setOpen} className={cn(className ?? '')}>
            <CollapsibleTrigger className='w-full'>
                <div className='min-h-14 flex justify-between items-center px-4 py-2 bg-customOrange break-all'>
                    <div
                        className={cn(
                            'flex-1 text-left text-background-3 text-xl font-medium',
                            classNameTitle
                        )}
                    >
                        {title}
                    </div>
                    <div className='text-background-3 content-center'>
                        {open ? <ChevronDown className='w-4 h-4' /> : <ChevronUp className='w-4 h-4' />}
                    </div>
                </div>
            </CollapsibleTrigger>
            <CollapsibleContent className='w-full bg-background-3 p-6 '>
                {children}
            </CollapsibleContent>
        </Collapsible>
    );
};

export default memo(TestCollapsible);
